import { useEffect } from 'react';

/**
 * lifecycle item will lose style on dragging
 * this hook is to simulate dom structure to maintain style during dragging
 */

export const LifecycleContainerHelpClass = 'life-cycle-drag-container-helper';
const removeHelperClass = 'lifecycle-node-remove';
const template = `<div class="project-detail lifecycle-hide-body-container">
      <div class="life-cycle">
            <div class="lifecycle-phases-container ${LifecycleContainerHelpClass}">
            </div>
      </div>
  </div>`;

function useDragContainerHelper() {
  useEffect(() => {
    if (!document.querySelector(`.${removeHelperClass}`)) {
      const helperNode = document.createElement('div');
      helperNode.classList.add(removeHelperClass);
      helperNode.innerHTML = template;
      document.body.appendChild(helperNode);
    }
    return () => {
      const nodeToRemove = document.querySelector(`.${removeHelperClass}`);
      if (nodeToRemove) {
        document.body.removeChild(nodeToRemove);
      }
    };
  }, []);
}

export default useDragContainerHelper;
